<template>
    <div>
        <el-tabs
                tab-position="top"
                type="border-card"
        >
            <el-tab-pane label="基础配置">
                <el-form label-width="120px">
                    <el-form-item :label="$t('m.basic_info')">
                        <my-input
                                :label="$t('m.name')"
                                :nullable="false"
                                v-model="detail.name"
                        ></my-input>
                        <my-input
                                :label="$t('m.path')"
                                v-model="detail.path"
                                :preffix="`http://${ address }/proxy/`"
                                :nullable="false"
                                width="400px"
                        ></my-input>
                        <my-select
                                v-model="detail.groupId"
                                :options="groups"
                                :label="$t('m.api_group')"
                                option_label="name"
                                option_value="id"
                                :nullable="false"
                        ></my-select>

                        <div style="display: flex;align-items: baseline;">
                            <span class="label">*代理地址</span>
                            <el-input
                                    placeholder="代理地址"
                                    v-model="detail.proxyPath"
                                    style="width:1180px"
                                    :autosize="{ minRows: 5, maxRows: 8}"
                                    type="textarea"
                            ></el-input>
                        </div>

                    </el-form-item>

                    <el-form-item label="参数">
                        <div slot="label">
                            <span >请求参数</span>
                        </div>
                        <div>
                            <el-table
                                    :data="detail.params"
                                    border
                                    stripe
                                    max-height="700"
                                    size="mini"
                                    empty-text="暂无参数"
                            >
                                <el-table-column
                                        prop="name"
                                        label="参数名称"
                                        width="220px"
                                >
                                    <template slot-scope="scope">
                                        <el-autocomplete
                                                v-model="scope.row.name"
                                                :fetch-suggestions="parseParams"
                                        ></el-autocomplete>
                                    </template>
                                </el-table-column>
                                <el-table-column
                                        label="参数类型"
                                        width="220px"
                                >
                                    <template slot-scope="scope">
                                        <el-select
                                                v-model="scope.row.type"
                                                :options="options"
                                        >
                                            <el-option
                                                    v-for="item in options"
                                                    :key="item.value"
                                                    :label="item.label"
                                                    :value="item.value"
                                            ></el-option>
                                        </el-select>
                                    </template>
                                </el-table-column>
                                <el-table-column
                                        label="参数说明"
                                        width="300px"
                                >
                                    <template slot-scope="scope">
                                        <el-input v-model="scope.row.note"></el-input>
                                    </template>
                                </el-table-column>

                                <el-table-column
                                        label="操作"
                                        width="100px"
                                >
                                    <template slot-scope="scope">
                                        <el-button
                                                @click="deleteRow(scope.$index)"
                                                circle
                                                type="danger"
                                                icon="el-icon-delete"
                                                size="mini"
                                        ></el-button>
                                    </template>
                                </el-table-column>
                            </el-table>
                            <el-button
                                    @click="addRow"
                                    icon="el-icon-plus"
                                    type="primary"
                                    circle
                                    size="mini"
                            ></el-button>
                        </div>

                    </el-form-item>

                    <el-form-item label="权限">
                        <el-radio-group v-model="detail.previlege">
                            <el-radio :label="PREVILEGE.PRIVATE">{{ $t('m.private') }}</el-radio>
                            <el-radio :label="PREVILEGE.PUBLIC">{{ $t('m.public') }}</el-radio>
                        </el-radio-group>

                        <el-tooltip
                                placement="top-start"
                                effect="dark"
                        >
                            <div slot="content">
                                {{ $t('m.access_tip') }}
                            </div>
                            <i class="el-icon-info tip"></i>
                        </el-tooltip>
                    </el-form-item>

                </el-form>
            </el-tab-pane>
        </el-tabs>
    </div>
</template>

<script>
    import sqlCode from "@/components/api/common/SqlCode";
    import MySelect from "../common/MySelect";
    import {DATA_TYPE, PREVILEGE} from "@/constant";

    export default {
        components: {
            MySelect,
            sqlCode,
        },
        data() {
            return {
                PREVILEGE: Object.freeze(PREVILEGE),
                datasources: [],
                address: null,
                show: false,
                groups: [{label: "姓名", value: "name"}],
                dialogVisible: false,
                detail: {
                    name: null,
                    path: null,
                    proxyPath:null,
                    params: [],
                    groupId: null,
                    previlege: PREVILEGE.PRIVATE, //访问权限
                },
                options: [
                    {label: "string", value: DATA_TYPE.STRING},
                    {label: "bigint", value: DATA_TYPE.BIGINT},
                    {label: "double", value: DATA_TYPE.DOUBLE},
                    {label: "date", value: DATA_TYPE.DATE},
                    {label: "string 数组", value: DATA_TYPE.ARRAY_STRING},
                    {label: "bigint 数组", value: DATA_TYPE.ARRAY_BIGINT},
                    {label: "double 数组", value: DATA_TYPE.ARRAY_DOUBLE},
                    {label: "date 数组", value: DATA_TYPE.ARRAY_DATE},
                ],
                table: null,
                tables: [],
                columns: [],
                column: null,
                isFullScreen: false,
                mode: "mini",
                cachePlugins: [],
                transformPlugins: [],
                alarmPlugins: [],
            };
        },
        props: ["id"],
        methods: {

            addRow() {
                this.detail.params.push({name: null, type: null});
            },
            deleteRow(index) {
                this.detail.params.splice(index, 1);
            },

            parseParams(queryString, cb) {
                this.axios
                    .post("/agentConfig/parseParam", {sql: this.detail.sql})
                    .then((response) => {
                        if (response.data.success) {
                            cb(response.data.data);
                        } else {
                            this.$message.error(response.data.msg);
                            cb([]);
                        }
                    })
                    .catch((error) => {
                        // this.$message.error("失败")
                        cb([]);
                    });
            },

            getAddress() {
                this.axios
                    .post("/agentConfig/getIPPort")
                    .then((response) => {
                        this.address = response.data;
                    })
                    .catch((error) => {
                        // this.$message.error("失败")
                    });
            },

            getDetail(id) {
                this.id = id;
                this.axios.post("/agentConfig/detail/" + id).then((response) => {
                    this.detail.name = response.data.name;
                    this.detail.path = response.data.path.substring(6);
                    this.detail.proxyPath = response.data.proxyPath;
                    this.detail.previlege = response.data.previlege;
                    this.detail.groupId = response.data.groupId;
                    this.detail.params = JSON.parse(response.data.params);
                });
            },

            getAllGroups() {
                this.axios
                    .post("/group/getAll/")
                    .then((response) => {
                        this.groups = response.data;
                    })
                    .catch((error) => {
                    });
            },
            getAllPlugin() {
                this.axios
                    .post("/plugin/all")
                    .then((response) => {
                        this.cachePlugins = response.data.cache;
                        this.transformPlugins = response.data.transform;
                        this.alarmPlugins = response.data.alarm;
                        this.interceptorPlugins = response.data.interceptor;
                    })
                    .catch((error) => {
                    });
            },
        },
        mounted() {
            this.getAddress();
            //编辑页面
            if (this.id != undefined) {
                this.getDetail(this.id);
            }
            // 新增页面
            else {
                this.$store.commit("initSqls", [
                    {
                        sqlText: "-- 请输入sql，一个标签只能输入一条sql",
                        transformPlugin: null,
                        transformPluginParams: null,
                    },
                ]);
            }
            this.getAllGroups();
            this.getAllPlugin();
        },
    };
</script>

<style scoped lang="scss">
    .my > .el-textarea__inner {
        font-family: "Consolas", Helvetica, Arial, sans-serif;
        /*font-size: 18px;*/
    }

    .mydialog > .el-dialog {
        margin-top: 20px !important;
        margin-bottom: 0px !important;
    }

    i {
        color: #0698a5;
        font-size: 18px;
        font-weight: 700;
        margin-right: 5px;
    }

    .tip {
        /*display: inline-block !important;*/
        margin-left: 10px;
        /*background-color: #fdf6ec;*/
        /*padding: 15px;*/
        color: #afafaf;
        font-size: 20px;
        font-weight: 100;
    }

    a {
        font-size: 16px;
        color: #afafaf;
        margin: 0 5px;

        &:hover {
            color: #000000;
        }
    }

    .textarea {
        /deep/ .el-textarea__inner {
            font-family: "Consolas", Helvetica, Arial, sans-serif !important;
            font-size: 16px !important;
            line-height: 20px;
        }
    }

    /*.label {*/
        /*margin: 0 5px 0 15px;*/
    /*}*/
    .label {
        display: inline-block;
        background-color: #08245E;
        //height: 40px;
        padding: 0 10px;
        color: #fff;
        border: 0px solid #a7a7a7;
        border-radius: 5px 0 0 5px;
        //vertical-align: middle;
    }
</style>
